/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_StandingsInputs */



/**
* | output |
* | --- |
* | "Standings" |
*
* @param {Tournament_StandingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_standings = /** @type {((inputs?: Tournament_StandingsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_StandingsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Classement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Clasificaciones")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Classificações")
	if (locale === "it") return /** @type {LocalizedString} */ ("Classifiche")
	return /** @type {LocalizedString} */ ("Standings")
});